import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { RADOM_COLORS } from '../util/Constants'
import { ManagedPaymentMethod } from '../util/Managed'
import NumberInput from './NumberInput'
import PaymentMethodDisplay from './PaymentMethodDisplay'

const OnrampDiv = styled.div`
  padding: 20px;
  max-width: 100%;
  min-width: 100%;
  background-color: ${() => RADOM_COLORS.GRAY_LIGHTEST};
  border-radius: 20px;
`

interface OnrampProps {
  method: ManagedPaymentMethod
  amount: string
  /** Shown while there is no amount. */
  placeholder?: string
  loading?: boolean
  tag: string
  style?: React.CSSProperties
}

export const OnrampComponent = ({
  method,
  amount,
  placeholder = '0',
  tag,
  loading,
  style
}: OnrampProps): ReactElement => {
  return (
    <OnrampDiv style={style}>
      <span style={{
        fontSize: 12,
        textTransform: 'uppercase',
        fontFamily: 'Roboto Mono',
        color: RADOM_COLORS.GRAY_DARKEST
      }}>
        {tag}
      </span>
      <div style={{ display: 'flex', gap: 10 }}>
        <NumberInput
          placeholder={placeholder}
          value={amount}
          style={{
            fontSize: 22,
            border: 0,
            padding: '10px 0',
            boxShadow: 'none',
            fontWeight: 500,
            color: 'black',
            background: 'transparent'
          }}
          disabled={true}
          onUserInput={(input) => { }} />
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 5,
          backgroundColor: RADOM_COLORS.GRAY_MED,
          padding: 10,
          borderRadius: 20,
          marginBottom: 12,
          cursor: 'pointer',
          userSelect: 'none',
          color: 'black',
          boxShadow: 'none'
        }}>
          <PaymentMethodDisplay
            size={28}
            method={method}
            excludeName />
          <span style={{ fontSize: 16, fontWeight: 500, marginLeft: 5 }}>
            {method.ticker}
          </span>
        </div>
      </div>
      {/* your content here */}
    </OnrampDiv>
  )
}
